export default __webpack_public_path__ + "static/Top_Web_Developers-beb41315e50091886e3559f0e523214d.png";